import { NearByDestinationsLoaderWrapper } from './NearByDestinationsSkeletonLoader.styles';

export const NearByDestinationsSkeletonLoader = () => {
  return (
    <NearByDestinationsLoaderWrapper>
      <div className="skeleton-loader near-by-destination-header"></div>
      <div className="near-by-destination-container">
        <div className="skeleton-loader near-by-destination-card"></div>
        <div className="skeleton-loader near-by-destination-card"></div>
        <div className="skeleton-loader near-by-destination-card"></div>
      </div>
    </NearByDestinationsLoaderWrapper>
  );
};

export default NearByDestinationsSkeletonLoader;
